import { css } from 'styled-components';
import { colorCSS } from './colors';
import { breakpoints } from './breakpoints';
import { fontSizes } from './textSize';
// to style UiMarkdown and UiTextBlock consistently
export function getOrderedListCSS(appearance) {
    if (!appearance) {
        return css `
      ol,
      ul {
        text-align: left;
        p {
          margin: 0;
        }
      }
    `;
    }
    return css `
    ol {
      counter-reset: ol-counter;
      list-style: none;
      padding-left: 0;
      li {
        counter-increment: ol-counter;
        font-size: ${fontSizes.lg};
        margin-bottom: 2rem;
        padding-left: 5rem;
        @media (max-width: ${breakpoints.sm}px) {
          padding-left: 4rem;
        }
        strong {
          display: block;
        }
        p {
          margin-bottom: 0;
          display: inline;
        }
        &::before {
          display: block;
          position: absolute;
          margin-left: -5rem;
          color: ${colorCSS('T400')};
          ${appearance === 'UpperAlpha'
        ? `content: counter(ol-counter, upper-alpha);`
        : `content: '0' counter(ol-counter);`}
          font-weight: 500;
          font-size: 2.5rem;
          margin-top: -0.5rem;
          @media (max-width: ${breakpoints.sm}px) {
            font-size: ${fontSizes.xl};
            margin-left: -4rem;
            margin-top: -0.25rem;
          }
        }
      }
      li:nth-child(n + 10)::before {
        ${appearance === 'Number' && 'content: counter(ol-counter);'}
      }
    }
  `;
}
//# sourceMappingURL=orderedLists.js.map